<template>
  <transition name="ip-slide">
    <div v-if="showBanner" class="ip-banner">
      <p class="ip-message">{{ $t('pwa.installMessage') }}</p>
      <div class="ip-actions">
        <button class="ip-btn ip-btn-install" @click="install">{{ $t('pwa.installBtn') }}</button>
        <button class="ip-btn ip-btn-dismiss" @click="dismissInstall">{{ $t('pwa.installDismiss') }}</button>
      </div>
    </div>
  </transition>
</template>

<script>
var DISMISS_KEY = 'pwa_install_dismissed_at'
var DISMISS_DURATION = 7 * 24 * 60 * 60 * 1000 // 7 天

export default {
  name: 'InstallPrompt',
  data () {
    return {
      showBanner: false,
      deferredPrompt: null
    }
  },
  mounted () {
    if (window.matchMedia('(display-mode: standalone)').matches) return

    var dismissed = localStorage.getItem(DISMISS_KEY)
    if (dismissed && (Date.now() - Number(dismissed)) < DISMISS_DURATION) return

    window.addEventListener('beforeinstallprompt', this.handlePrompt)
  },
  beforeDestroy () {
    window.removeEventListener('beforeinstallprompt', this.handlePrompt)
  },
  methods: {
    handlePrompt (e) {
      e.preventDefault()
      this.deferredPrompt = e
      this.showBanner = true
    },
    async install () {
      if (!this.deferredPrompt) return
      this.deferredPrompt.prompt()
      var result = await this.deferredPrompt.userChoice
      this.deferredPrompt = null
      this.showBanner = false
      if (result.outcome === 'dismissed') {
        localStorage.setItem(DISMISS_KEY, String(Date.now()))
      }
    },
    dismissInstall () {
      this.showBanner = false
      this.deferredPrompt = null
      localStorage.setItem(DISMISS_KEY, String(Date.now()))
    }
  }
}
</script>

<style scoped>
.ip-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9998;
  background: #fff;
  border-top: 1px solid #e0e0e0;
  box-shadow: 0 -3px 10px rgba(0, 0, 0, 0.1);
  padding: 14px 20px;
  text-align: center;
}

.ip-message {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
}

.ip-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.ip-btn {
  padding: 8px 22px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
}

.ip-btn-install {
  background: #1a73e8;
  color: #fff;
}

.ip-btn-install:hover {
  background: #1557b0;
}

.ip-btn-dismiss {
  background: #f0f0f0;
  color: #666;
}

.ip-btn-dismiss:hover {
  background: #e4e4e4;
}

.ip-slide-enter-active,
.ip-slide-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.ip-slide-enter,
.ip-slide-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>
